export enum ESearchLevel {
    STATE = 'state',
    MUNICIPALITY = 'municipality',
    NEIGHBORHOOD = 'neighborhood',
    BLOCK = 'block',
    PROPERTY = 'property'
}